import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SubSink } from 'subsink';
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay
} from 'swiper/core';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export interface CarouselItem{
  id: string|number,
  type?:'video'|'image'
}

export interface CarouselImage extends CarouselItem{
  //type optional because of usage in featuresales
  type?:'image',
  url: {
    lazyLoad: string,
    default: string,
    error: string
  }
  altText?: string,
  titleText?: string
}

export interface CarouselVideo extends CarouselItem{
  type:'video',
  quality:string,
  startSeconds:number,
  endSeconds:number
}

@Component({
  selector: 'kion-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit, OnDestroy {

  @Input() showNavigationOnlyDesktop: boolean;
  @Input() items: CarouselItem[];
  //group size is default 2
  @Input() groupSize = 2;
  @Input() activeSlide = 0;


  // tslint:disable-next-line:no-output-rename
  @Output('update') activeSlideUpdatedEmitter: EventEmitter<number> = new EventEmitter<number>();

  windowSize$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  private subSink: SubSink;

  @Input() project: "LR" | "FS" | "Dematic" | string;

  constructor() {
    this.subSink = new SubSink();
  }

  ngOnInit(): void {
    this.windowSize$.next(window.innerWidth);
    this.windowSize$
      .subscribe(
        (windowSize: number) => {
          //if windowSize is below 768, set groupSize to 1
          if (windowSize <= 768) {
            this.groupSize = 1;
          }
        }
      );
  }

  updateSlide(index : any){
    this.activeSlideUpdatedEmitter.emit(index.activeIndex)

  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe()
  }
}
